import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  CASE_REMOVE_PAGES_BEGIN,
  CASE_REMOVE_PAGES_SUCCESS,
  CASE_REMOVE_PAGES_FAILURE,
  CASE_REMOVE_PAGES_DISMISS_FEEDBACK,
  CASE_FETCH_DOCUMENTS_BEGIN,
  CASE_FETCH_FOLDER_BEGIN,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import {
  withCurrentCaseId,
  selectCurrentFolder,
  selectEnableNotifications,
} from '../../../common/selectors';

export const removePagesDocument = createPromiseAction(CASE_REMOVE_PAGES_BEGIN);

export function dismissRemovePagesDocumentFeedback() {
  return {
    type: CASE_REMOVE_PAGES_DISMISS_FEEDBACK,
  };
}

const buildRemovePagesUrl = (caseId, fileId) =>
  `/cases/${caseId}/files/${fileId}/remove-pages`;

export function* doRemovePagesDocument(action) {
  const {
    payload: { caseId, fileId, pagesToRemove, newDoc },
  } = action;
  const isNotificationEnabled = yield select(selectEnableNotifications);

  try {
    const requestPayload = {
      pagesToRemove,
      ...(newDoc && {
        newDoc: {
          name: newDoc.name,
          folderId: newDoc.folderId,
        },
      }),
    };
    const response = yield call(api.post, buildRemovePagesUrl(caseId, fileId), requestPayload);

    if (response && response.error) {
      yield put({
        type: CASE_REMOVE_PAGES_FAILURE,
        feedback: {
          message: 'feedback.removePagesDocumentFailure',
          error: response.error,
          retryAction: action,
        },
      });
      return yield call(rejectPromiseAction, action, response);
    }

    const currentFolder = yield select(selectCurrentFolder);
    if (currentFolder) {
      yield put({ type: CASE_FETCH_DOCUMENTS_BEGIN });
      yield put({
        type: CASE_FETCH_FOLDER_BEGIN,
        payload: { folderId: currentFolder.id, noPromise: true },
      });
    }

    yield put({
      type: CASE_REMOVE_PAGES_SUCCESS,
      ...(!isNotificationEnabled && {
        feedback: { message: 'feedback.removePagesDocumentSuccess' },
      }),
    });
    yield call(resolvePromiseAction, action, response);

    return response;
  } catch (error) {
    yield put({
      type: CASE_REMOVE_PAGES_FAILURE,
      feedback: {
        message: 'feedback.removePagesDocumentFailure',
        error: error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, { error });
  }
}

export function* watchRemovePagesDocument() {
  yield takeLatest(removePagesDocument, withCurrentCaseId(doRemovePagesDocument));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_REMOVE_PAGES_BEGIN + '.TRIGGER':
      return {
        ...state,
        removePagesDocumentPending: true,
        removePagesDocumentFeedback: null,
      };

    case CASE_REMOVE_PAGES_SUCCESS:
      return {
        ...state,
        removePagesDocumentPending: false,
        removePagesDocumentFeedback: action.feedback,
      };

    case CASE_REMOVE_PAGES_FAILURE:
      return {
        ...state,
        removePagesDocumentPending: false,
        removePagesDocumentFeedback: action.feedback,
      };

    case CASE_REMOVE_PAGES_DISMISS_FEEDBACK:
      return {
        ...state,
        removePagesDocumentFeedback: null,
      };

    default:
      return state;
  }
}
